module.exports = __webpack_public_path__ + "img/MR.e3ae53f7.svg";